const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenInNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.448,
    xmlns: "http://www.w3.org/2000/svg",
    height: 24.983,
    id: "screenshot-764fa8e9-4807-8007-8002-56ffb4aafdf6",
    viewBox: "0 0 25.448 24.983",
    style: {
      WebkitPrintColorAdjust: "exact"
    },
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-764fa8e9-4807-8007-8002-56ffb4aafdf6",
    height: 48,
    width: 48,
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-764fa8e9-4807-8007-8002-56ffb4aafdf8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-764fa8e9-4807-8007-8002-56ffb4aafdf8"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M4.772,21.860C4.347,21.860,3.976,21.704,3.658,21.391C3.340,21.079,3.181,20.715,3.181,20.298L3.181,4.684C3.181,4.268,3.340,3.904,3.658,3.591C3.976,3.279,4.347,3.123,4.772,3.123L12.167,3.123L12.167,4.684L4.772,4.684L4.772,20.298L20.677,20.298L20.677,13.038L22.267,13.038L22.267,20.298C22.267,20.715,22.108,21.079,21.790,21.391C21.472,21.704,21.101,21.860,20.677,21.860L4.772,21.860ZZM10.126,16.161L9.013,15.042L19.563,4.684L13.758,4.684L13.758,3.123L22.267,3.123L22.267,11.476L20.677,11.476L20.677,5.803L10.126,16.161ZZ",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInNew);
export default __webpack_public_path__ + "static/media/open-in-new.b9118bd6bf734b9af96c90743c4cf3c2.svg";
export { ForwardRef as ReactComponent };